import React from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import { TimetableTimeSlotsFilters, adminTimetableSectors, adminTimetableSectors_adminTimetableSectors, OrderDirection } from '@api/graphql/types';
import { Tabs, Tab } from '@components/Tab';
import Drawer from '@components/Drawer';
import TimetableListFilter from '../components/TimetableListFilter';
import TimetableSlotsTable from '../components/TimetableSlotsTable';
import { DispatchProp, connect } from 'react-redux';
import { updateListOptions } from '@actions/listActions';
import { Loading } from '@components/Loading';
import { ApplicationState } from 'reducers/';
import { ListOptionType } from '@reducers/listReducer';
import DailySummary from '../components/DailySummary';
import moment from 'moment';

interface State {
    sectors: Array<(adminTimetableSectors_adminTimetableSectors | null)> | [];
}

const TimetableDefaultOptions = {
    sortBy: {
        field: 'id',
        direction: OrderDirection.ASC,
    },
    count: 10,
    page: 0,
    filters: {
        id: null,
        range_date: moment().format('YYYY-MM-DD'),
        status: null,
        timetable_sector_id: null,
    },
};

const listName = 'timetable';

interface ReduxProps {
    listOptions: ListOptionType;
}

type Props = ReduxProps & DispatchProp & InjectedIntlProps;


class TimetableList extends React.Component<Props, State> {
    public state = {
        sectors: [],
    };

    public componentDidMount() {
        this.fetchSectors();
    }

    private fetchSectors = () => {
        GraphQLClient.query<adminTimetableSectors>({
            query: Queries.adminTimetableSectors,
        }).then((response) => {
            this.setState({sectors: response.data.adminTimetableSectors});
        });
    }

    public render() {
        if (this.state && this.state.sectors) {
            return (
                <Drawer>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-content">
                                    <TimetableListFilter
                                        value={this.props.listOptions.filters}
                                        onSubmit={(filters: TimetableTimeSlotsFilters) => {
                                            const options = {...this.props.listOptions, filters};
                                            const action = updateListOptions(listName, options);
                                            this.props.dispatch(action);
                                        }}
                                    />
                                    <Tabs>
                                        {this.state.sectors!.map((sector: adminTimetableSectors_adminTimetableSectors ) => {
                                            if (!sector) {
                                                return <div id="empty" />;
                                            }
                                            return (
                                                <Tab key={`sector-${sector.id}`} id={`sector-${sector.id}`} label={sector.name}>
                                                    <TimetableSlotsTable sectorId={sector.id} filters={this.props.listOptions.filters} />
                                                </Tab>
                                            );
                                        })}
                                    </Tabs>
                                    <DailySummary filters={this.props.listOptions.filters} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Drawer>
            );
        }
        return <Loading />;
    }
}


const mapStateToProps = ({ lists }: ApplicationState): ReduxProps => {
    return { listOptions: (lists ? (lists[listName] || TimetableDefaultOptions) : TimetableDefaultOptions) };
};

export default compose(
    injectIntl,
    connect(mapStateToProps),
)(TimetableList);



// WEBPACK FOOTER //
// ./src/modules/Timetable/pages/TimetableList.tsx